import { wsClient, WsRecvType, IWsHandler } from '../client'

export interface IVolumeMeasureStatus {
    clientId: string
    volumeMl: number
    isPouring: number
    error: number
    errorMsg?: string
}

type IVolumeMeasureStatusHandler = IWsHandler<IVolumeMeasureStatus>

const listeners: Array<(data: IVolumeMeasureStatus) => void> = []

export function onVolumeMeasureStatus(callback: (data: IVolumeMeasureStatus) => void) {
    listeners.push(callback)
    return () => {
        const index = listeners.indexOf(callback)
        if (index > -1) {
            listeners.splice(index, 1)
        }
    }
}

export default function () {
    wsClient.submitHandler(WsRecvType.VolumeMeasureStatus, ((packet) => {
        const data = packet.data
        if (!data) return
        listeners.forEach(listener => listener(data))
    }) as IVolumeMeasureStatusHandler)
}
